import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Img from "../../../images/podcast/ep-1.png";
import {LazyLoadImage} from "react-lazy-load-image-component";


function Banner({data}) {
    return (

        <div className="services_banner ">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="my-auto">
                        <div className="example" data-text="Tek Podcast">
                            <h1>What Does Automation Mean for a Business in The 21st century?</h1>
                        </div>
                        <div
                            className="banner_content_txt listing_flex">
                            <p>In Episode 7, Tekrevol’s Co-Founder and CMO Abeer Raza is joined by the Co-Founder of Remote New Media and Code Assembly, Mr.Paul McGillivray. The podcast features a discussion on ground-breaking automation, scaling and pivoting a business using process automation, the application of lean methodology, and what is required for a successful digital transformation of a business in the 21st century. From the service to the e-commerce industry you will find key insights on how you can automate your business to improve efficiency and achieve digital growth.</p>
                        </div>
                    </Col>
                    <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto text-center">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;